import { isArray, isEmptyString, isNotNull } from "utils/types/typeguards";
import { useTranslation } from "react-i18next";
import React from "react";

type Props = {
	productTextId: string
	image?: string
}

function SingleProductPageBasicInformation({
	productTextId,
	image
}: Props) {

	const { t } = useTranslation();

	const title = t([ `products.${ productTextId }.basicInformation.title`, "" ]);
	const textOne = t([ `products.${ productTextId }.basicInformation.textOne`, "" ]);
	const textTwo = t([ `products.${ productTextId }.basicInformation.textTwo`, "" ]);
	const listTitle1 = t([ `products.${ productTextId }.basicInformation.list1.title`, "" ]);
	const listTitle2 = t([ `products.${ productTextId }.basicInformation.list2.title`, "" ]);
	const listDescription1 = t([ `products.${ productTextId }.basicInformation.list1.description`, "" ]);
	const listDescription2 = t([ `products.${ productTextId }.basicInformation.list2.description`, "" ]);
	const listElements1 = t([ `products.${ productTextId }.basicInformation.list1.elements`, "" ], { returnObjects: true }) as string[] | string;
	const listElements2 = t([ `products.${ productTextId }.basicInformation.list2.elements`, "" ], { returnObjects: true }) as string[] | string;

	const hasAnyElements = (): boolean => !(
		isEmptyString(title) &&
		isEmptyString(textTwo) &&
		isEmptyString(textTwo) &&
		isEmptyString(listTitle1) &&
		isEmptyString(listTitle2) &&
		isEmptyString(listDescription1) &&
		isEmptyString(listDescription2) &&
		!isArray(listElements1) &&
		!isArray(listElements2)
	)

	if (!hasAnyElements()) return <></>

	return (
		<div className="container">
			<div className="flex flex-col items-center lg:flex-row gap-20 bg-white rounded-3xl mt-10">
				<div className="flex flex-col gap-4">
					{
						!isEmptyString(title) &&
                        <h2 className="text-black font-medium">
							{ title }
                        </h2>
					}
					{
						isNotNull(image) &&
                        <img src={ image } alt="PRODUCT_IMAGE" className="lg:hidden w-[250px] rounded-2xl mx-auto"/>
					}
					<div className="flex flex-col gap-4 text-base font-normal text-left">
						{
							!isEmptyString(textOne) &&
                            <div dangerouslySetInnerHTML = {{ __html: textOne } } />
						}
						{
							!isEmptyString(textTwo) &&
                            <div dangerouslySetInnerHTML = {{ __html: textTwo } } />
						}
					</div>
					<div>
						{
							!isEmptyString(listTitle1) &&
                            <div className="font-medium">
								{ listTitle1 }
                            </div>
						}
						{
							!isEmptyString(listDescription1) &&
                            <div>
								{ listDescription1 }
                            </div>
						}
						{
							isArray(listElements1) &&
                            <ul className="ml-5">
								{
									listElements1.map(element =>
										<li className="flex items-center gap-4">
											<div className="list-check"/>
											{ element }
										</li>
									)
								}
                            </ul>
						}
					</div>
					<div>
						{
							!isEmptyString(listTitle2) &&
                            <div className="font-medium">
								{ listTitle2 }
                            </div>
						}
						{
							!isEmptyString(listDescription2) &&
                            <div className="font-light">
								{ listDescription2 }
                            </div>
						}
						{
							isArray(listElements2) &&
                            <ul className="ml-5">
								{
									listElements2.map(element =>
										<li className="flex items-center gap-4">
											<div className="list-check"/>
											{ element }
										</li>
									)
								}
                            </ul>
						}
					</div>
				</div>
				<img src={ image } alt="PRODUCT_IMAGE" className="hidden lg:block max-w-[500px] h-[300px] rounded-2xl object-contain"/>
			</div>
		</div>
	);
}

export default SingleProductPageBasicInformation;